<template>
	<ShutterPanel />
</template>

<script type="text/javascript">
	import ShutterPanel from 'GroomyRoot/components/Utils/ShutterPanel'
	import Shutter from '@/mixins/Shutter'
	import MonteShutters from '@/mixins/shutters-manager/Monte'

	export default {
		name: 'PlanningMonteIA',
		mixins: [Shutter, MonteShutters],
		data () {
			return {
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				let shutter = this.monteShutters['monte-ia-calendar']
				this.shutterPanel().open(shutter)			
			},
		},

		computed: {
		},

		components: {
			ShutterPanel
		}
	}

</script>